import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledRide, StawavScheduledRideInput } from '@/models/scheduledRide';

export const createStaWavScheduledRide = async ({ data }: { data: StawavScheduledRideInput }): Promise<ScheduledRide> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateStaWavScheduledRide($data: StawavScheduledRideInputType!) {
        createStaWavScheduledRide(data: $data) {
          id
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createStaWavScheduledRide!;
};
